import { useMemo } from "react";

import type { DistributionDelivery } from "@skilitics/interact-designer-distribution";

import { useDistributionDeliveryApiClient } from "./useDistributionDeliveryApiClient.ts";

export const useDistributionDelivery = (): DistributionDelivery => {
  const deliveryApiClient = useDistributionDeliveryApiClient();
  return useMemo(
    (): DistributionDelivery => ({
      api: deliveryApiClient,
      options: {
        prereleaseDeliveryEnabled: import.meta.env.REACT_APP_PRERELEASE_DELIVERY_ENABLED === "true",
        prereleaseSuffix: import.meta.env.REACT_APP_PRERELEASE_DELIVERY_SUFFIX || undefined,
      },
    }),
    [deliveryApiClient],
  );
};
